var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShoes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Footwear-Heels-Ankle--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Footwear Heels Ankle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 16c-5.3 -3.69 -6.17 -7.77 -6.29 -8.31a1.46 1.46 0 0 0 -1.71 -1.11c-4.4 0.84 -7.37 -0.62 -10.27 -5a1.45 1.45 0 0 0 -2.45 0A8.43 8.43 0 0 0 0.3 4a10.35 10.35 0 0 0 0 5.1 62.79 62.79 0 0 1 1 12.13 1.95 1.95 0 0 0 3.89 0l0 -5.68a0.51 0.51 0 0 1 0.3 -0.55 0.49 0.49 0 0 1 0.56 0.18 38.83 38.83 0 0 1 4.34 6.92 1.93 1.93 0 0 0 1.7 1H20a3.94 3.94 0 0 0 3.93 -3.1 3.8 3.8 0 0 0 -1.83 -4ZM2.19 4.5c0.08 -0.28 0.17 -0.56 0.27 -0.82a0.24 0.24 0 0 1 0.2 -0.15 0.25 0.25 0 0 1 0.23 0.1c3 4 6.33 5.6 10.71 5a0.49 0.49 0 0 1 0.54 0.34 16 16 0 0 0 4.26 6.53 0.5 0.5 0 0 1 0.15 0.42 0.51 0.51 0 0 1 -0.23 0.37l-0.68 0.42c-2.07 0.94 -3.63 -0.62 -5.93 -3.3 -2 -2.25 -4.32 -5 -7.41 -3.8a0.49 0.49 0 0 1 -0.54 -0.12C3.3 9 2.75 8.47 2.23 8a0.54 0.54 0 0 1 -0.17 -0.3 7.88 7.88 0 0 1 0.13 -3.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 14.07a0.98 0.98 0 1 0 1.96 0 0.98 0.98 0 1 0 -1.96 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68 11.2a0.98 0.98 0 1 0 1.96 0 0.98 0.98 0 1 0 -1.96 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoes);
export default ForwardRef;